import CbbDropdown from './CbbDropdown';
import { createAdaptiveDropdown } from './createAdaptiveDropdown';

import rightArrow from '../public/images/arrow-right.svg';

// See createAdaptiveDropdown for the shared implementation.
// Base classes/icon are copied from CbbDropdown so both breakpoints match.
const CbbAdaptiveDropdown = createAdaptiveDropdown(CbbDropdown, {
  rootBaseClassName:
    'custom-dropdown flex items-center no-focus relative bg-white box-border justify-between xl:mr-0 pl-3 pr-4 py-2 border cursor-pointer border-beige-dark',
  arrowIcon: rightArrow,
  arrowSize: 22,
});

export default CbbAdaptiveDropdown;
